<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>系统公告配置</span>
          <clear-cache-apply />
        </div>
        <el-button
          v-permisaction="['config:announcement2:add']"
          style="margin:0px 0px 10px 0px;"
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="edit(0)"
        >新增</el-button>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="newVersion"
            label="新版本"
            align="center"
          />
          <!--          <el-table-column-->
          <!--            prop="stime"-->
          <!--            label="开始时间"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="etime"-->
          <!--            label="结束时间"-->
          <!--            align="center"-->
          <!--          />-->

          <el-table-column
            prop="device"
            label="设备类型"
            :formatter="deviceFormatter"
            align="center"
          />

          <el-table-column
            prop="reward"
            label="奖励"
            align="center"
            :formatter="getRewardList"
          />

          <el-table-column
            prop="admin_user"
            label="操作用户"
            align="center"
          />

          <el-table-column
            prop="createtime"
            label="创建时间"
          />

          <el-table-column
            fixed="right"
            label="操作"
            width="400"
          >
            <template slot-scope="scope">
              <el-button v-permisaction="['config:announcement2:add']" size="mini" @click="edit(scope.row.id)">编辑</el-button>
              <el-button v-permisaction="['config:announcement2:copy']" type="primary" size="mini" @click="copy(scope.row.id)">拷贝</el-button>
              <el-button v-if="scope.row.device === 0 || scope.row.device === 1" v-permisaction="['config:announcement2:async']" :loading="loading" type="success" size="mini" @click="confirmBox(scope.row.id,'AndroidVersion')">同步安卓</el-button>
              <el-button v-if="scope.row.device === 0 || scope.row.device === 2" v-permisaction="['config:announcement2:async']" :loading="loading" type="success" size="mini" @click="confirmBox(scope.row.id,'IosVersion')">同步苹果</el-button>
              <el-button v-permisaction="['config:announcement2:del']" size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align: center">
          <!--          <el-button v-permisaction="['config:hotUpdate:add']" type="primary" @click="add()">+</el-button>-->
          <!--          <el-button v-permisaction="['config:startExchange:add']" type="primary" @click="onSubmit()">保存</el-button>-->
        </div>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>

      <el-dialog width="25%" title="同步到指定版本" :visible.sync="dialogFormVisible">
        <el-form :model="asyncForm">
          <el-form-item label="选择版本">
            <el-select v-model="asyncForm.version" placeholder="请选择">
              <el-option
                v-for="item in versionArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="asyncOss()">确 定</el-button>
        </div>
      </el-dialog>

    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import submenu from 'element-ui/packages/submenu'
import {
  AsyncAnnouncement2List,
  copyAnnouncement2List,
  delAnnouncement2,
  getAnnouncement2List
} from '@/api/config/announcement-cfg2'
import { getRewardType } from '@/api/config/slot'
import { getRewardListForPropsId } from '@/utils'
import { getCommonCfg } from '@/api/config/common-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
export default {
  name: 'Announcement2',
  components: { ClearCacheApply },
  data() {
    return {
      asyncForm: {
        version: '',
        id: '',
        type: ''
      },
      versionArr: [],
      dialogFormVisible: false,
      loading: false,
      rewardType: [],
      drawer: false,
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      propsId: 19,
      statusType: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      deviceType: [
        { label: '安卓', value: 'android' },
        { label: '苹果', value: 'ios' }
      ],
      options: [],
      formData: {},
      tableData: [
        {
          'id': 0,
          'title': '',
          'content': '',
          'stime': '',
          'etime': 0,
          'device': '',
          'reward': [],
          'fansUrl': '',
          'admin_user': '',
          'version': '',
          'createtime': '',
          'time_desc': '',
          'range_desc': '',
          'topic': '',
          'newVersion': '',
          'is_force': '',
          'img': '',
          'plat': ''
        }
      ]
    }
  },
  computed: {
    submenu() {
      return submenu
    }
  },
  created() {
    this.getVersion()
    this.getRewardTypeData()
    this.getTables()
    // this.getChestSkin()
  },
  methods: {
    confirmBox(id, device) {
      this.asyncForm.id = id
      this.asyncForm.type = device
      this.dialogFormVisible = true
    },
    asyncOss() {
      this.$confirm('此操作将将同步到S3, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogFormVisible = false
        this.loading = true
        AsyncAnnouncement2List({ version: this.asyncForm.version, id: this.asyncForm.id, name: this.asyncForm.type }).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.asyncForm = {
              version: '',
              type: '',
              id: ''
            }
            this.msgSuccess(res.msg)
          } else {
            this.msgError(res.msg)
          }
        })
      }).catch(_ => {
        this.dialogFormVisible = false
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    copy(id) {
      copyAnnouncement2List({ id: id }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    edit(id) {
      this.$router.push({ name: 'Announcement2Edit', query: { id: id }})
    },
    getTables() {
      this.formData = []
      getAnnouncement2List(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(id, index) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delAnnouncement2({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    getChestSkin() {
      getChestCfgAll().then(res => {
        if (res.code === 200) {
          this.options = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    }, getReward(row, col, prize) {
      const str = []
      for (const i in prize) {
        const r = prize[i]
        for (const k in this.rewardType) {
          const rt = this.rewardType[k]
          if (r.propsId === rt.value) {
            str.push(rt.label + '*' + r.num)
          }
        }
      }
      return str.join(',')
    }, getForce(row, col) {
      if (row.gu_force === 1) {
        return '是'
      }
      return '否'
    },
    deviceFormatter(row, col, val) {
      const deviceArr = ['全部', '安卓', '苹果']
      return deviceArr[val]
    },
    getRewardList(row, col, prize) {
      return getRewardListForPropsId(prize, this.rewardType)
    },
    getVersion() {
      getCommonCfg({ name: 'StaticVersion' }).then(res => {
        res.data.forEach(item => {
          this.versionArr.unshift({ label: item, value: item })
        })
      })
    }
  }
}
</script>

<style scoped>
</style>
